module.exports = __webpack_public_path__ + "media/club/ohra-edit-24638d93.webp";